//Reference: EN055

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class ReasonCancelWork extends Mappeable {

    idReasonClosePk: number;
    txtReason: string;
    codReason: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtReason: this.txtReason,
            codReason: this.codReason,
            mrkActive: this.mrkActive,
        }
    }

}